import Api from 'api';

import {
  GET_GROUPS,
  SET_GROUPS_PAGINATION,
  SET_GROUPS_FILTERS,
  RESET_GROUPS,
  TOGGLE_GROUP,
  ADD_GROUP,
  UPDATE_GROUP,
  GET_GROUP_BY_ID,
  RESET_GROUP_FORM,
  MODIFY_EDITING_GROUP,
} from 'groups/constants';

export const setPagination = (payload) => ({
  type: SET_GROUPS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_GROUPS_FILTERS,
  payload,
});

export const getGroups = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_GROUPS,
  payload: Api.groups.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_GROUPS });

export const toggleGroup = (groupId, companyId, subcompanyId) => ({
  type: TOGGLE_GROUP,
  meta: { id: groupId },
  payload: Api.groups.toggle(groupId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_GROUP_FORM });

export const getGroupById = (groupId, companyId, subcompanyId) => ({
  type: GET_GROUP_BY_ID,
  meta: { needAuth: true },
  payload: Api.groups.getById(groupId, companyId, subcompanyId),
});

export const modifyGroup = (payload) => ({ type: MODIFY_EDITING_GROUP, payload });

export const addGroup = (companyId, subcompanyId, group) => ({
  type: ADD_GROUP,
  payload: Api.groups.add(companyId, subcompanyId, group),
});

export const updateGroup = (groupId, companyId, subcompanyId, group) => ({
  type: UPDATE_GROUP,
  meta: { id: groupId, needAuth: true },
  payload: Api.groups.update(groupId, companyId, subcompanyId, group),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/actions/groups_actions.js